module.exports = __webpack_public_path__ + "4a849ecd363953c8e42b6b60fd5a3994.mp4";